import { EventSourceHandler } from '@sellsy/sse';

export default class SamSubscriptionCreatedEventSourceHandler extends EventSourceHandler {
    constructor(){
        super()
        this.type = 'corporation.sam.subscription.created'
    }

    handle(event){
        $('.subscribebar').remove();
    }
}